<!-- 水平衡月分析 -->
<template>
  <div class="m-water-analysis">
    <a-card :bordered="false">
      <a-form-model ref="form" :model="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }"
        class="small-input-form">
        <!-- 片区选择 -->
        <a-form-model-item label="片区名称">
          <a-tree-select v-model="query.zoneId" style="width: 100%" :tree-data="zoneTreeData"
            :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择片区" allow-clear show-search
            treeNodeFilterProp="title" @change="handleZoneChange" />
        </a-form-model-item>

        <!-- 时间选择 -->
        <a-form-model-item label="时间">
          <div style="display: flex; flex-direction: column;">
            <a-radio-group v-model="query.timeType" button-style="solid" @change="handleTimeTypeChange"
              style="margin-bottom: 10px;">
              <a-radio-button value="year">年份</a-radio-button>
              <a-radio-button value="quarter">季度</a-radio-button>
              <a-radio-button value="month">月份</a-radio-button>
              <a-radio-button value="other">其他</a-radio-button>
            </a-radio-group>

            <div class="date-picker-wrapper" style="display: flex; align-items: center; flex-wrap: nowrap;">
              <a-date-picker v-if="query.timeType === 'year'" mode="year" format="YYYY" v-model="query.date"
                placeholder="请选择年份" :open="yearOpen" @openChange="handleYearOpenChange"
                @panelChange="handleYearPanelChange" style="width: 150px;" :disabled-date="disabledDate" />
              <template v-else-if="query.timeType === 'quarter'">
                <a-date-picker mode="year" format="YYYY" v-model="query.date" placeholder="请选择年份" :open="yearOpen"
                  @openChange="handleYearOpenChange" @panelChange="handleYearPanelChange" style="width: 150px;"
                  :disabled-date="disabledDate" />
                <a-select v-model="query.quarter" placeholder="请选择季度" style="width: 120px; margin-left: 10px;">
                  <a-select-option v-for="i in 4" :key="i" :value="i">第{{ i }}季度</a-select-option>
                </a-select>
              </template>
              <a-month-picker v-else-if="query.timeType === 'month'" v-model="query.date" placeholder="请选择月份"
                style="width: 150px;" :disabled-date="disabledDate" />
              <a-range-picker v-else v-model="query.dateRange" style="width: 240px;" :disabled-date="disabledDate" />

              <a-button type="primary" @click="handleGetData" :loading="loading"
                style="margin-left: 10px;">获取数据</a-button>
            </div>
          </div>
        </a-form-model-item>

        <!-- 数据表单项 -->
        <a-form-model-item label="供水总量(m³)">
          <a-input v-model="form.supplyWater" disabled placeholder="自动计算：区域流入水量 - 区域流出水量" />
        </a-form-model-item>

        <a-form-model-item label="区域流入水量(m³)">
          <a-input v-model="form.intakeWaterGaugeCount" type="number" placeholder="点击获取数据" />
        </a-form-model-item>

        <a-form-model-item label="区域流出水量(m³)">
          <a-input v-model="form.exitWaterGaugeCount" type="number" placeholder="点击获取数据" />
        </a-form-model-item>

        <a-form-model-item label="注册供水量(m³)">
          <a-input v-model="form.registerWater" type="number" />
        </a-form-model-item>

        <a-form-model-item label="计费用水量(m³)">
          <a-input v-model="form.costWater" type="number" />
        </a-form-model-item>

        <a-form-model-item label="居民用水量(m³)">
          <a-input v-model="form.residentWater" type="number" />
        </a-form-model-item>

        <a-form-model-item label="非居民用水量(m³)">
          <a-input v-model="form.noResidentWater" type="number" />
        </a-form-model-item>

        <a-form-model-item label="特种用水量(m³)">
          <a-input v-model="form.specialWater" type="number" />
        </a-form-model-item>

        <a-form-model-item label="免费用水量(m³)">
          <a-input v-model="form.freeWater" type="number" />
        </a-form-model-item>

        <a-form-model-item label="免费计量用水量(m³)">
          <a-input v-model="form.freeCalculateQuantityWater" type="number" />
        </a-form-model-item>

        <a-form-model-item label="免费未计量用水量(m³)">
          <a-input v-model="form.freeNoCalculateQuantityWater" type="number" />
        </a-form-model-item>

        <a-form-model-item label="漏损水量(m³)">
          <a-input v-model="form.leakageWater" type="number" placeholder="自动计算：供水总量 - 注册供水量" />
        </a-form-model-item>

        <a-form-model-item label="产销差率(%)">
          <a-input v-model="form.productionMarketing" disabled placeholder="自动计算：漏损水量/供水总量*100%" />
        </a-form-model-item>

        <a-form-model-item label="DN75mm以上管道长度(公里)">
          <a-input v-model="form.pipLineLength" type="number" placeholder="点击获取数据" />
        </a-form-model-item>

        <a-form-model-item label="单位供水管长(万吨/公里)">
          <a-input v-model="form.pipLineLengthWater" disabled placeholder="自动计算：供水总量/DN75以上管网长度/1000" />
        </a-form-model-item>

        <a-form-model-item label="修正值R1、R2、R3、R4">
          <a-input v-model="form.modificationValue" type="number" placeholder="请输入修正值总和" />
        </a-form-model-item>

        <a-form-model-item label="管网漏损率">
          <a-input v-model="form.pipelineNetworkLeakageRate" disabled placeholder="自动计算：产销差率 - 修正值" />
        </a-form-model-item>

        <!-- 底部按钮 -->
        <a-form-model-item :wrapper-col="{ span: 12, offset: 6 }">
          <div class="action-buttons">
            <a-button type="primary" @click="handleExport">导出</a-button>
          </div>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import axios from 'axios'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import storage from 'store'
import moment from 'moment'

export default {
  name: 'MWaterAnalysis',
  data () {
    return {
      loading: false,
      yearOpen: false,
      query: {
        zoneId: undefined,
        timeType: 'month',
        date: moment(),
        quarter: undefined,
        dateRange: []
      },
      zoneTreeData: [],
      form: {
        supplyWater: '', // 供水总量
        intakeWaterGaugeCount: '', // 区域流入水量
        exitWaterGaugeCount: '', // 区域流出水量
        registerWater: '', // 注册供水量
        costWater: '', // 计费用水量
        residentWater: '', // 居民用水量
        noResidentWater: '', // 非居民用水量
        specialWater: '', // 特种用水量
        freeWater: '', // 免费用水量
        freeCalculateQuantityWater: '', // 免费计量用水量
        freeNoCalculateQuantityWater: '', // 免费未计量用水量
        leakageWater: '', // 漏损水量
        productionMarketing: '', // 产销差率
        pipLineLength: '', // DN75mm以上管道长度
        pipLineLengthWater: '', // 单位供水管长
        modificationValue: '', // 修正值
        pipelineNetworkLeakageRate: '' // 管网漏损率
      }
    }
  },
  created () {
    this.getZoneData()
  },
  watch: {
    // 监听流入流出计算供水总量
    'form.intakeWaterGaugeCount': 'calcWaterSupplyTotal',
    'form.exitWaterGaugeCount': 'calcWaterSupplyTotal',

    // 监听供水总量和漏损水量计算产销差率
    'form.supplyWater': function () {
      this.calcLeakageWater()
      this.calcUnitPipeLength()
    },
    'form.leakageWater': 'calcCxcRate',

    // 监听供水总量和管道长度计算单位供水管长
    'form.pipLineLength': 'calcUnitPipeLength',

    // 监听产销差率和修正值计算管网漏损率
    'form.productionMarketing': 'calcPipeLeakageRate',
    'form.modificationValue': 'calcPipeLeakageRate',

    // 监听居民、非居民、特种用水量计算计费用水量
    'form.residentWater': 'calcCostWater',
    'form.noResidentWater': 'calcCostWater',
    'form.specialWater': 'calcCostWater',

    // 监听免费计量、免费未计量用水量计算免费用水量
    'form.freeCalculateQuantityWater': 'calcFreeWater',
    'form.freeNoCalculateQuantityWater': 'calcFreeWater',

    // 监听计费用水量、免费用水量计算注册供水量
    'form.costWater': 'calcRegisterWater',
    'form.freeWater': 'calcRegisterWater',

    // 监听注册供水量计算漏损水量
    'form.registerWater': 'calcLeakageWater'
  },
  methods: {
    moment,
    // 获取片区数据
    getZoneData () {
      this.$http.get('zone-metering/zone-metering').then(({ data }) => {
        this.zoneTreeData = data
      })
    },
    handleZoneChange (value) {
      console.log('Selected Zone:', value)
    },
    handleTimeTypeChange () {
      this.query.date = moment()
      this.query.quarter = 1
      this.query.dateRange = []
    },
    // 年份选择器控制
    handleYearOpenChange (open) {
      if (open) {
        this.yearOpen = true
      } else {
        this.yearOpen = false
      }
    },
    handleYearPanelChange (value) {
      this.query.date = value
      this.yearOpen = false
    },
    // 限制日期不能选择今天之后
    disabledDate (current) {
      if (['year', 'month'].includes(this.query.timeType)) {
        return current && current > moment().subtract(1, 'days').endOf('day')
      }
      return current && current > moment().endOf('day')
    },
    // 统一获取计算后的开始和结束日期
    getQueryDates () {
      let beginDate = ''
      let endDate = ''
      const today = moment().endOf('day')
      const yesterday = moment().subtract(1, 'days').endOf('day')

      if (this.query.timeType === 'year' && this.query.date) {
        beginDate = this.query.date.clone().startOf('year').format('YYYY-MM-DD')
        endDate = this.query.date.clone().endOf('year').format('YYYY-MM-DD')
      } else if (this.query.timeType === 'quarter' && this.query.date && this.query.quarter) {
        const year = this.query.date.year()
        const date = moment().year(year).quarter(this.query.quarter)
        beginDate = date.clone().startOf('quarter').format('YYYY-MM-DD')
        endDate = date.clone().endOf('quarter').format('YYYY-MM-DD')
      } else if (this.query.timeType === 'month' && this.query.date) {
        beginDate = this.query.date.clone().startOf('month').format('YYYY-MM-DD')
        endDate = this.query.date.clone().endOf('month').format('YYYY-MM-DD')
      } else if (this.query.timeType === 'other' && this.query.dateRange && this.query.dateRange.length === 2) {
        beginDate = this.query.dateRange[0].format('YYYY-MM-DD')
        endDate = this.query.dateRange[1].format('YYYY-MM-DD')
      }

      // 核心需求：年份和月份的 endDate 时间最多只能到昨天
      let limitDate = today
      if (['year', 'month'].includes(this.query.timeType)) {
        limitDate = yesterday
      }

      if (endDate && moment(endDate).isAfter(limitDate)) {
        endDate = limitDate.format('YYYY-MM-DD')
      }

      return { beginDate, endDate }
    },

    // 计算供水总量
    calcWaterSupplyTotal () {
      const inflow = parseFloat(this.form.intakeWaterGaugeCount)
      const outflow = parseFloat(this.form.exitWaterGaugeCount)

      if (!isNaN(inflow) && !isNaN(outflow)) {
        this.form.supplyWater = (inflow - outflow).toFixed(2)
      } else if (!isNaN(inflow)) {
        this.form.supplyWater = inflow.toFixed(2)
      } else {
        this.form.supplyWater = ''
      }
    },

    // 计算产销差率 = 漏损水量/供水总量*100%
    calcCxcRate () {
      const leakage = parseFloat(this.form.leakageWater)
      const total = parseFloat(this.form.supplyWater)

      if (!isNaN(leakage) && !isNaN(total) && total !== 0) {
        this.form.productionMarketing = ((leakage / total) * 100).toFixed(2)
      } else {
        this.form.productionMarketing = ''
      }
    },

    // 计算单位供水管长 = 供水总量/DN75以上管网长度/1000
    calcUnitPipeLength () {
      const total = parseFloat(this.form.supplyWater)
      const length = parseFloat(this.form.pipLineLength)

      if (!isNaN(total) && !isNaN(length) && length !== 0) {
        this.form.pipLineLengthWater = (total / length / 1000).toFixed(4)
      } else {
        this.form.pipLineLengthWater = ''
      }
    },

    // 计算管网漏损率 = 产销差率 - 修正值
    calcPipeLeakageRate () {
      const cxc = parseFloat(this.form.productionMarketing)
      const correction = parseFloat(this.form.modificationValue)

      if (!isNaN(cxc) && !isNaN(correction)) {
        this.form.pipelineNetworkLeakageRate = (cxc - correction).toFixed(2)
      } else {
        this.form.pipelineNetworkLeakageRate = ''
      }
    },

    // 计算计费用水量 = 居民用水量 + 非居民用水量 + 特种用水量
    calcCostWater () {
      const resident = parseFloat(this.form.residentWater) || 0
      const nonResident = parseFloat(this.form.noResidentWater) || 0
      const special = parseFloat(this.form.specialWater) || 0

      this.form.costWater = (resident + nonResident + special).toFixed(2)
    },

    // 计算免费用水量 = 免费计量用水量 + 免费未计量用水量
    calcFreeWater () {
      const metered = parseFloat(this.form.freeCalculateQuantityWater) || 0
      const unmetered = parseFloat(this.form.freeNoCalculateQuantityWater) || 0

      this.form.freeWater = (metered + unmetered).toFixed(2)
    },

    // 计算注册供水量 = 计费用水量 + 免费用水量
    calcRegisterWater () {
      const cost = parseFloat(this.form.costWater) || 0
      const free = parseFloat(this.form.freeWater) || 0

      this.form.registerWater = (cost + free).toFixed(2)
    },

    // 计算漏损水量 = 供水总量 - 注册供水量
    calcLeakageWater () {
      const supply = parseFloat(this.form.supplyWater)
      const register = parseFloat(this.form.registerWater)

      if (!isNaN(supply) && !isNaN(register)) {
        this.form.leakageWater = (supply - register).toFixed(2)
      } else {
        // 如果需要重置
        // this.form.leakageWater = ''
      }
    },

    // 获取数据
    handleGetData () {
      if (!this.query.zoneId) {
        this.$message.warning('请先选择片区')
        return
      }

      this.loading = true

      const { beginDate, endDate } = this.getQueryDates()

      const params = {
        zoneId: this.query.zoneId,
        beginDate,
        endDate
      }

      this.$http.get('/zone-metering/leakage/level/rule/water/balance', { params })
        .then(({ data }) => {
          if (data) {
            // 只获取指定字段
            this.form.intakeWaterGaugeCount = data.intakeWaterGaugeCount
            this.form.exitWaterGaugeCount = data.exitWaterGaugeCount
            this.form.supplyWater = data.supplyWater
            // 接口单位是米，转换为公里
            this.form.pipLineLength = data.pipLineLength ? (parseFloat(data.pipLineLength) / 1000).toFixed(3) : ''

            this.$message.success('数据获取成功')
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    // 导出
    handleExport () {
      const { beginDate, endDate } = this.getQueryDates()
      let params = {
        ...this.form,
        zoneId: this.query.zoneId,
        beginDate,
        endDate
      }
      // 实现导出逻辑
      this.loading = true
      const token = storage.get(ACCESS_TOKEN)
      axios({
        url: process.env.VUE_APP_API_BASE_URL + 'zone-metering/leakage/level/rule/water/fx/export',
        method: 'get',
        params: params,
        responseType: 'blob',
        headers: {
          Authorization: token
        }
      }).then(res => {
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
        const fileName = '水平衡月分析.xlsx'
        if ('download' in document.createElement('a')) { // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else { // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
        this.$message.success('导出成功')
      }).catch(err => {
        console.error('导出失败:', err)
        this.$message.error('导出失败')
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.m-water-analysis {
  background-color: #fff;
  padding: 24px;
  min-height: 100%;

  .time-select-wrapper {
    display: flex;
    align-items: center;
  }

  .action-buttons {
    display: flex;
    justify-content: flex-start;
  }

  /deep/ .small-input-form {
    .ant-form-item-control-wrapper {
      max-width: 600px;
    }
  }
}
</style>